<template>
  <section class="live-page">
    <MSportTabs
      :items="sportTabs"
      :selected-tab="selectedTabsIds[0]"
      is-live
      :all-counter="liveCounter"
      class="mobile-tabs"
      @select="handleSelectTabs"
    />
    <div class="events" data-t="live-events-1t71">
      <MSportPageHeader :header-color="headerColor" class="page-header">
        <StLiveIndicator :size="16" color="orange" />
        <h1 class="page-title">{{ t('events.liveNow') }}</h1>
        <MMarketsFilterList v-model="activeFilter" class="filters" />
      </MSportPageHeader>
      <MSportListSkeleton v-if="!isFullActualLoaded" />
      <MSportList
        v-else
        class="events-list"
        :render-full-tree="fullSportsTree"
        :active-filter="activeFilter"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import MSportList from '@st/bookmaker/components/SportList/MSportList.vue'
import MSportTabs from '@st/bookmaker/components/SportTabs/MSportTabs.vue'
import MSportPageHeader from '@st/bookmaker/components/SportPageHeader/MSportPageHeader.vue'
import MMarketsFilterList from '@st/bookmaker/components/MarketsFilter/MMarketsFilterList.vue'
import type { MobileMarketsFilterType } from '@st/bookmaker/types'

definePageMeta({
  layout: 'mobile',
})

const live = useLiveEvents()
const liveCounter = computed(() => live.value.length)
const activeFilter = ref<MobileMarketsFilterType>('exodus')
const { fullSportsTree } = useInitSportTree(live, { state: 'live' })
const { sportTabs, selectedTabsIds, handleSelectTabs } = useSportTabs(live, {
  scrollTop: 0,
})

const { t } = useI18n()
const { headerColor } = useMobileLayout()

const { isFullActualLoaded } = useFullActualLoaded()

useSeoData('sport-live')
</script>
<style scoped>
.events {
  background-color: v-bind(headerColor);
}

.mobile-tabs {
  position: sticky;
  z-index: 10;
  top: 48px;
  padding-top: var(--spacing-050);
}

.page-title {
  margin: 0;
  font: var(--mobile-title-2-semibold);
}

.page-header {
  border-bottom: var(--border-width-light) solid var(--border-primary);
}

.filters {
  margin-left: auto;
}
</style>
